import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRequestExporter  {
    _originalTypeClassName = "zERP.BO.LeaveRequestExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRequestExporter.translate = translateService;
}
this.LeaveRequestExporterKey = null;
this._key = this.LeaveRequestExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _LeaveRequestExporterKey:any;
get LeaveRequestExporterKey(): any {
    return this._LeaveRequestExporterKey;
  }
set LeaveRequestExporterKey(value: any) {
    this._LeaveRequestExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(leaveRequest: any): any{let vars = new window['Map']();
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "MODIFICATIONS") {let budgetAdjustmentDetail = Joove.Common.cast(item, "Domain.BudgetAdjustmentDetail");switch (varName?.toLowerCase()) {case "account_code":
{
return budgetAdjustmentDetail?.BudgetDetail?.BudgetItem?.Code;}
case "account_description":
{
return budgetAdjustmentDetail?.BudgetDetail?.BudgetItem?.Name;}
case "approved_amount":
{
return budgetAdjustmentDetail?.BudgetDetail?.InitialApprovedAmount?.toString();}
case "adjustment_amount":
{
return budgetAdjustmentDetail?.ApprovedAmount?.toString();}
case "updated_amount":
{
return (Joove.Common.safeNumber(budgetAdjustmentDetail?.BudgetDetail?.InitialApprovedAmount) + Joove.Common.safeNumber(budgetAdjustmentDetail?.BudgetDetail?.AdjustmentsAmount))?.toString();}
}}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LeaveRequestExporterKey == null || $this.LeaveRequestExporterKey == 0;
            }


}